import type { SimulationOptions } from './types';

const DESIGN_OWNED_OPTION_KEYS = [
  'n_clusters',
  'cluster_spacing_m',
  'pump_rate_m3min',
  'perf_n',
  'perf_d_mm',
  'perf_cd',
  'cluster_params',
  'youngs_modulus',
  'poissons_ratio',
] as const;

const UFM_ONLY_OPTION_KEYS = [
  'natural_fracture_model_id',
  'natural_fracture_source_mode',
  'natural_fracture_design',
  'natural_fracture_sets',
  'nf_p3d_predictors',
  'nf_scenario_override',
] as const;

/** Stage, cluster, perforation and treatment inputs are resolved from FracDesign. */
export const solverOptionsOnly = (options: SimulationOptions): Record<string, unknown> => {
  const sanitized: Record<string, unknown> = { ...options };
  DESIGN_OWNED_OPTION_KEYS.forEach((key) => delete sanitized[key]);
  if (options.model_type !== 'PKN') delete sanitized.frac_height;
  if (options.model_type !== 'UFM') {
    UFM_ONLY_OPTION_KEYS.forEach((key) => delete sanitized[key]);
    sanitized.natural_fractures_enabled = false;
    sanitized.natural_fracture_branch = false;
    sanitized.unified_fracture_network = false;
  }
  return sanitized;
};
